import { render, staticRenderFns } from "./ImportArtistOrders.vue?vue&type=template&id=4274a5a7"
import script from "./ImportArtistOrders.vue?vue&type=script&lang=js"
export * from "./ImportArtistOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports